import {
  FormControl,
  FormHelperText,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  TextField
} from '@mui/material';
import { ProductScheduleItem } from '../../@types/model/productSchedule';
import ProductTypePicker from 'components/ProductTypePicker';
import SvgIconStyle from 'components/SvgIconStyle';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';

export interface ProductScheduleItemFormProps {
  productScheduleItem: ProductScheduleItem;
  submitHandler: (item: ProductScheduleItem) => void;
  deleteHandler: () => void;
  errors: any;
  touched: any;
}

const ProductScheduleItemForm = (props: ProductScheduleItemFormProps) => {
  const { t } = useTranslation();
  const [infinite, setInfinite] = useState<string>('no');
  const [previousQuantity, setPreviousQuantity] = useState<number>(
    props.productScheduleItem.quantity
  );
  useEffect(() => {
    if (props.productScheduleItem.quantity < 0) {
      setInfinite('yes');
    }
  }, []);
  return (
    <Grid container spacing={2} sx={{ mb: 3 }}>
      <Grid item xs={2} sm={1} md={1}>
        <TextField
          disabled
          fullWidth
          autoComplete={t('ordinal')}
          type="number"
          label={t('ordinal')}
          value={props.productScheduleItem.ordinal}
          error={Boolean(props.touched?.ordinal && props.errors?.ordinal)}
        />
        <FormHelperText style={{ color: 'red', marginBottom: 10 }}>
          {props.touched?.ordinal && props.errors?.ordinal}
        </FormHelperText>
      </Grid>
      {infinite === 'no' && (
        <Grid item xs={4} sm={3} md={2}>
          <TextField
            fullWidth
            autoComplete={t('quantity')}
            type="number"
            label={t('quantity')}
            value={props.productScheduleItem.quantity}
            onChange={(event) => {
              props.submitHandler({
                ...props.productScheduleItem,
                quantity: parseInt(event.target.value)
              });
            }}
            error={Boolean(props.touched?.quantity && props.errors?.quantity)}
          />
          <FormHelperText style={{ color: 'red', marginBottom: 10 }}>
            {props.touched?.quantity && props.errors?.quantity}
          </FormHelperText>
        </Grid>
      )}
      <Grid item xs={4} sm={3} md={2}>
        <TextField
          disabled
          fullWidth
          autoComplete={t('consumed')}
          type="number"
          label={t('consumed')}
          value={props.productScheduleItem.consumed}
          onChange={(event) => {
            props.submitHandler({
              ...props.productScheduleItem,
              consumed: parseInt(event.target.value)
            });
          }}
          error={Boolean(props.touched?.consumed && props.errors?.consumed)}
        />
        <FormHelperText style={{ color: 'red', marginBottom: 10 }}>
          {props.touched?.consumed && props.errors?.consumed}
        </FormHelperText>
      </Grid>
      <Grid item xs={10} sm={2} md={2}>
        <FormControl fullWidth>
          <InputLabel id={'product-type-select-label'}>{t('no_limit')}</InputLabel>
          <Select
            labelId={'product-type-select-label'}
            id={'product-type-select'}
            value={infinite}
            label={t('select_no_limit').toString()}
            onChange={(event) => {
              if (event.target.value === 'yes') {
                setPreviousQuantity(props.productScheduleItem.quantity);
                props.submitHandler({
                  ...props.productScheduleItem,
                  quantity: -1
                });
                setInfinite('yes');
              } else {
                props.submitHandler({
                  ...props.productScheduleItem,
                  quantity: previousQuantity
                });
                setInfinite('no');
              }
            }}
          >
            <MenuItem key={'no'} value={'no'}>
              {t('No')}
            </MenuItem>
            <MenuItem key={'yes'} value={'yes'}>
              {t('Yes')}
            </MenuItem>
          </Select>
        </FormControl>
      </Grid>
      <Grid item xs={10} sm={4} md={3}>
        <ProductTypePicker
          productTypePreset={props.productScheduleItem.product}
          changeHandler={(productTypePreset: string) =>
            props.submitHandler({
              ...props.productScheduleItem,
              product: productTypePreset
            })
          }
          productTypeAvailable={[]}
          error={props.errors?.product}
          touched={props.touched?.product}
        ></ProductTypePicker>
        <FormHelperText style={{ color: 'red', marginBottom: 10 }}>
          {props.touched?.product && props.errors?.product}
        </FormHelperText>
      </Grid>
      <Grid item xs={2} sm={1} md={1}>
        <IconButton onClick={() => props.deleteHandler()} size="large" color="error">
          <SvgIconStyle
            src="/static/icons/giraf/remove.svg"
            sx={{
              width: '30px',
              height: '30px',
              display: 'block',
              backgroundColor: 'red',
              color: 'white'
            }}
          />
        </IconButton>
      </Grid>
    </Grid>
  );
};
export default ProductScheduleItemForm;
